import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/** Formats a datetime value as "MMM DD, YYYY HH:mm" in the browser's local timezone. */
export const formatDateTime = (value: string | Date | number): string =>
    dayjs(value).format('MMM DD, YYYY HH:mm');

/** Formats a datetime value as a relative string (e.g. "2 hours ago") in the browser's local timezone. */
export const formatFromNow = (value: string | Date | number): string =>
    dayjs(value).fromNow();
